import { useEffect, useState, type ReactNode } from "react";
import CampaignCta from "@/components/CampaignCta";
import { isCampaignVisit } from "@/lib/attribution";

/** Tagged campaign visits get the Text Us CTA; organic visitors see the original button unchanged. */
export default function CampaignHeroCta({ children, refCode }: { children: ReactNode; refCode?: string }) {
  const [campaign, setCampaign] = useState(false);
  useEffect(() => setCampaign(isCampaignVisit()), []);
  return campaign ? <CampaignCta refCode={refCode} /> : <>{children}</>;
}
